import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HostUrlService } from "../host-url.service";

@Injectable({
  providedIn: "root",
})
export class HospitalHttpProviderService {
  constructor(private urlService: HostUrlService, private http: HttpClient) {}

  private baseURL = this.urlService.url + "/hospitals";

  getAllHospitals(): Observable<any> {
    return this.http.get(`${this.baseURL}/all`);
  }
  deleteHospitalById(id: any): Observable<any> {
    return this.http.delete(`${this.baseURL}/delete/${id}`);
  }
  getHospitalDetailsById(id: any): Observable<any> {
    return this.http.get(`${this.baseURL}/${id}`);
  }
  createHospital(data: any): Observable<any> {
    return this.http.post(`${this.baseURL}/create`, data);
  }
  updateHospital(data: any, id: string): Observable<any> {
    return this.http.put(`${this.baseURL}/update/${id}`, data);
  }
}
